import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ErrorBoundary } from './components/errors/ErrorBoundary';
import RouteLoader from './components/routing/RouteLoader';
import routes from './routes/routes';

const router = createBrowserRouter(routes);

function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <RouteLoader>
          <RouterProvider router={router} />
        </RouteLoader>
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default App;